import { Image } from '@chakra-ui/react';
import React from 'react';
import togetherForTheRunSrc from './together-for-the-run.png';

export const TogetherForTheRun = props => {
  return <Image src={togetherForTheRunSrc} {...props} />;
};
